import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import ogImage from '@/static/assets/home/og-nl.png';

export const config: BasePageConfig = {
  seo: {
    title: 'Lemonade Opstal, Inboedel en Aansprakelijkheidsverzekering',
    metaTitle: 'Lemonade Opstal, Inboedel en Aansprakelijkheidsverzekering',
    description:
      'Lemonade biedt inboedel- en aansprakelijkheidsverzekering aan. Gestuurd door tech en gedreven door sociaal belang. Geen papierwerk & alles direct geregeld.',
    ogImage: ogImage.src,
  },
  layout: {
    headerActions: {
      dropdown: {
        logout: 'Uitloggen',
        myAccount: 'Mijn Account',
        settings: 'Instellingen',
      },
      CTAs: {
        backToYourQuote: {
          long: {
            singular: 'Terug naar je offerte',
            plural: 'Terug naar je offerte',
          },
          short: {
            singular: 'OFFERTE',
            plural: 'OFFERTE',
          },
        },
        checkOurPrices: {
          long: {
            singular: 'Bekijk onze prijzen',
            plural: 'Bekijk onze prijzen',
          },
          short: {
            singular: 'Bekijk onze prijzen',
            plural: 'Bekijk onze prijzen',
          },
        },
      },
    },
  },
};
